export default __webpack_public_path__ + "static/media/logo.92dd2019.png";